export const ORDER_STATUS = Object.freeze({
  CREATE: 'create',
  PROCESS: 'process',
  PRE_COMPLETE: 'pre_complete',
  COMPLETE: 'complete',
  SUCCESS: 'success',
  CANCEL: 'cancel',
  OK: 'ok',
  EXPIRED: 'expired',
})

export const CONFIRM_PAYMENT_PAY_AT_STORE_TYPE = Object.freeze({
  EDC_CREDIT_CARD: 'edc_credit_card',
  EDC_QR: 'edc_qr',
  CASH: 'cash',
})

export const CONFIRM_PAYMENT_ORDER_TYPE = Object.freeze({
  GENERAL: 'general',
  WITH_PLAN: 'with_plan',
  WITH_TRADEIN: 'with_tradein',
  WITH_TRADEIN_LATER: 'with_tradein_later',
})

export const GUARANTEE_PAYMENT_STATUS = Object.freeze({
  CREATE: 'create',
  PROCESS: 'process',
  COMPLETED: 'completed',
})

export default ORDER_STATUS
